import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/platformChat',
    name: 'platformChat',
    component: () =>
        import('@/views/platformChat.vue')
}, {
    path: '/registerForDownload',
    name: 'registerForDownload',
    component: () =>
        import('@/views/registerForDownload.vue')
}, {
    path: '/inviteTechnicians',
    name: 'inviteTechnicians',
    component: () =>
        import('@/views/inviteTechnicians.vue')
}, {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () =>
        import('@/views/privacyPolicy.vue')
}, {
    path: '/userPolicy',
    name: 'userPolicy',
    component: () =>
        import('@/views/userPolicy.vue'),
    meta: {
        title: "用户协议",
    }
}, {
    path: '/downloadBusiness',
    name: 'downloadBusiness',
    component: () =>
        import('@/views/downloadBusiness.vue')
}, {
    path: '/downloadTechnician',
    name: 'downloadTechnician',
    component: () =>
        import('@/views/downloadTechnician.vue')
}, {
    path: '/downloadUser',
    name: 'downloadUser',
    component: () =>
        import('@/views/downloadUser.vue')
}]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router